import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

import '../css/frontend.css';

import './components/index';
import header from './components/initHeaderShrink';
import quickbar from './components/initQuickbar';
import scroller from './components/initScroller';

// Alpine — 마크업에서 바로 다루는 UI 상태(열고 닫기, 탭, 간단한 토글)를 맡는다.
// 서버와 주고받거나 여러 화면이 함께 쓰는 동작은 components/ 의 모듈로 둔다.
Alpine.plugin(collapse);
Alpine.data('header', header);
Alpine.data('quickbar', quickbar);
Alpine.data('scroller', scroller);
window.Alpine = Alpine;
Alpine.start();
